import { SNACKBAR_SHOW, SNACKBAR_HIDE } from '../../constants/actionTypes';

const INITIAL_STATE = {
  isVisible: false,
  text: '',
  type: '',
};

const applyShowSnackbar = (_, action) => ({
  ...action.payload,
  isVisible: true,
});

const applyHideSnackbar = () => ({
  ...INITIAL_STATE,
});

const snackbarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SNACKBAR_SHOW:
      return applyShowSnackbar(state, action);
    case SNACKBAR_HIDE:
      return applyHideSnackbar(state, action);
    default:
      return state;
  }
};

export default snackbarReducer;
